module.exports = __webpack_public_path__ + "img/full6-min.5d6d2237.png";